import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';
import { DocumentRequirement } from '../DocumentRequirement/DocumentRequirement';

type TProps = {
  quantifier: number;
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const VATReturns = ({
  quantifier,
  isOptional,
  isSubmitted,
  status,
}: TProps) => {
  return (
    <DocumentRequirement
      title="VAT returns"
      documentType="vat return"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <p>
        Your last {quantifier} months of VAT returns in PDF format. These should
        include the nine box summary page for each return. You don't need to
        include the detailed breakdowns for each VAT return.{' '}
        <a
          href="https://www.gov.uk/sign-in-vat-account"
          target="_blank"
          rel="noreferrer"
        >
          Learn more
        </a>
      </p>
    </DocumentRequirement>
  );
};
